// client/src/components/routes/AdminRoute.jsx
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { currentAdmin } from '../functions/auth';

const AdminRoute = ({ children }) => {
  const { user } = useSelector((s) => ({ ...s }));
  const [loading, setLoading] = useState(true);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    let mounted = true;
    const probe = async () => {
      try {
        if (!user?.token) {
          if (mounted) { setOk(false); setLoading(false); }
          return;
        }
        await currentAdmin(); // header จะติดจาก axios interceptor
        if (mounted) { setOk(true); setLoading(false); }
      } catch (e) {
        if (mounted) { setOk(false); setLoading(false); }
      }
    };
    probe();
    return () => { mounted = false; };
  }, [user?.token]);

  if (loading) return <div style={{ padding: 24 }}>กำลังตรวจสิทธิ์...</div>;
  return ok ? children : <Navigate to="/login" replace />;
};

export default AdminRoute;
